import CurriculumProgramAccordion from "./CurriculumProgramAccordion";
export default CurriculumProgramAccordion;
